import ImageService from '@services/ImageService';

const Image = Backbone.Model.extend( {

    defaults: {
        'id': null,
        'src': '',
        'thumbSrc': '',
        'altText': '',
        'videoId': null
    },

    getImageSrc: function ( type ) {
        return ImageService.getSizedUrl( {
            src: this.get( 'src' ),
            type: type
        } );
    }

} );

export default Image;
